
    <ol class="breadcrumb">
      <li class="breadcrumb-item" [class.active]="active" *ngFor="let breadcrumb of (location | async); let active = last; let i = index">
        <!-- Normal ancestor link -->
        <a [id]=" i + '_breadcrumb_link'" *ngIf="!active && breadcrumb.route" [routerLink]="breadcrumb.route">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </a>
        <!-- Non-linked active view indicator (or anything without route) -->
        <span *ngIf="(active && !linkActive) || !breadcrumb.route">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </span>
        <!-- Active view refresh link using full page load (i.e., standard html link, skip routing) -->
        <a [id]=" i + '_breadcrumb_link'" *ngIf="active && linkActive && !refreshPath && breadcrumb.route" [href]="breadcrumb.route!.join('/')">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </a>
        <!-- Active view refresh link using transitional route target -->
        <a [id]=" i + '_breadcrumb_link'" *ngIf="active && linkActive && refreshPath && breadcrumb.route" [href]="breadcrumb.route!.join('/')" (click)="refresh($event, breadcrumb.route)">
          <span *ngIf="breadcrumb.localizationKey">{{breadcrumb.localizationKey | translate}}</span>
          <span *ngIf="breadcrumb.localizationKey && breadcrumb.label">:</span>
          <span *ngIf="breadcrumb.label">{{breadcrumb.label | translateValue:true}}</span>
          <span *ngIf="breadcrumb.value">{{breadcrumb.value}}</span>
        </a>
      </li>
    </ol>
  